<template>
  <v-btn
      :outlined="outlined"
      :large="large"
      :absolute="absolute"
      :right="right"
      :left="left"
      :top="top"
      :bottom="bottom"
      :loading="loading"
      :rounded="rounded"
      small
      :height="height"
      :min-width="minWidth"
      :width="width"
      style="padding: 10px 20px"
      :class="['theme-'+theme]"
      :block="block"
      :disabled="disabled"
      @click="eventClick"
  >
    <v-icon v-if="prependIcon" class="mr-2">{{ prependIcon }}</v-icon>
    <v-img
        v-if="prependResIcon"
        :width="resSize"
        :max-width="resSize"
        :max-height="resSize"
        contain
        class="mr-2"
        :src="prependResIcon"
    ></v-img>
    <div class="txt-bigger" style="letter-spacing: 0">{{ label }}</div>
    <slot v-if="!label"></slot>
    <v-icon v-if="icon" color="var(--theme-color-seven)">{{ icon }}</v-icon>
    <v-icon v-if="appendIcon" class="ml-2">{{ appendIcon }}</v-icon>
    <v-img
        v-if="appendResIcon"
        :width="resSize"
        :max-width="resSize"
        :max-height="resSize"
        contain
        class="ml-2"
        :src="appendResIcon"
    ></v-img>
  </v-btn>
</template>

<script>
export default {
  name: 'Button',
  props: {
    label: {
      default: ''
    },
    loading: {
      default: false
    },
    color: {
      default: 'var(--theme-color-two)'
    },
    rounded: {
      default: false
    },
    minWidth: {
      default: '77px'
    },
    absolute: {
      default: false
    },
    right: {
      default: false
    },
    left: {
      default: false
    },
    top: {
      default: false
    },
    bottom: {
      default: false
    },
    outlined: {
      default: false
    },
    large: {
      default: false
    },
    block: {
      default: false
    },
    width: {
      default: 'unset'
    },
    height: {
      default: '40px'
    },
    disabled: {
      default: false
    },
    icon: {
      default: undefined
    },
    prependIcon: {
      default: undefined
    },
    prependResIcon: {
      default: undefined
    },
    appendIcon: {
      default: undefined
    },
    appendResIcon: {
      default: undefined
    },
    resSize: {
      default: '25px'
    },
    type: {
      default: '1'
    },
    theme: {
      default: '1'
    }
  },
  data () {
    return {
      // type1: {
      //   bgColor: 'var(--theme-color-two)',
      //   textColor: 'var(--theme-color-one)'
      // },
      // type2: {
      //   bgColor: 'var(--theme-color-one)',
      //   textColor: 'var(--theme-color-two)'
      // },
      // type3: {
      //   bgColor: 'var(--theme-color-two)',
      //   textColor: 'var(--theme-color-five)'
      // }
    }
  },
  methods: {
    eventClick() {
      this.$emit('onClick')
    }
  }
}
</script>

<style scoped lang="scss">
.theme-1 {
  background: linear-gradient(21.01deg, var(--theme-color-seven) 6.18%, #FBB040 84.83%);
  color: #fff !important;
  font-size: 14px !important;
  font-family: var(--font-bold-type);
  border-radius: 30px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
  height: 35px;
}
.theme-2 {
  background-color: #D9D9D9 !important;
  color: var(--theme-color-two) !important;
  font-size: 14px !important;
  font-family: var(--font-bold-type);
  border-radius: 30px;
  box-shadow: none;
  height: 35px;
}
.theme-3 {
  background-color: var(--theme-color-two) !important;
  color: #fff !important;
  font-size: 14px !important;
  font-family: var(--font-bold-type);
  border-radius: 30px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
  height: 35px;
}
.theme-4 {
  background-color: #FBB040 !important;
  color: #fff !important;
  font-size: 14px !important;
  font-family: var(--font-bold-type);
  border-radius: 30px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
  height: 35px;
}
.theme-5 {
  background-color: var(--theme-color-eight) !important;
  color: #fff !important;
  font-size: 14px !important;
  font-family: var(--font-bold-type);
  border-radius: 30px;
  box-shadow: none;
  height: 35px;
}
.theme-6 {
  background-color: var(--theme-color-seven) !important;
  color: #fff !important;
  font-size: 14px !important;
  font-family: var(--font-bold-type);
  border-radius: 30px;
  box-shadow: none;
  height: 35px;
}
.theme-7 {
  background-color: var(--theme-color-three) !important;
  color: #fff !important;
  font-size: 14px !important;
  font-family: var(--font-bold-type);
  border-radius: 30px;
  height: 35px;
}
.theme-8 {
  background-color: #fff !important;
  color: var(--theme-color-four) !important;
  border: solid 1px var(--theme-color-four) !important;
  font-size: 14px !important;
  font-family: var(--font-bold-type);
  border-radius: 30px;
  height: 35px;
  box-shadow: none !important;
}
</style>
